import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { AuthService } from '../../auth/auth.service';
import { Medium } from '../medium.model';
import { MediaService } from '../media.service';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';

@Component({
  selector: 'fnsr-medium-details',
  standalone: true,
  imports: [LoadComponent],
  templateUrl: './medium-details.component.html',
  styleUrls: ['./medium-details.component.scss']
})
export class MediumDetailsComponent implements OnInit {
  medium?: Medium;
  formMessage?: FormMessage;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public mediaService: MediaService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(param => {
      this.getMedium(param['id']);
    });
  }

  getMedium(id: string): void {
    this.mediaService.getMedium(id).subscribe(
      result => this.medium = result,
      err => console.log(err)
    );
  }

  deleteMedium(): void {
    if (confirm('Möchtest Du dieses Medium wirklich löschen?')) {
      if (this.medium) {
        this.mediaService.deleteMedium(this.medium._id).subscribe(
          result => {
            console.log(result);
            this.router.navigate(['medium/list'])
          },
          (err: Error) => console.log(err)
        );
      }
    }
  }
}
